/**
 * A view for progress
 * @class
 */
import Base from '@netx/core/lib/netx-view';
import Template from '../templates/appProgressView.html';

class AppProgressView extends Base {
	/** @override */
	constructor(opts = {}) {
		opts.eventStr = opts.eventStr || 'foo:bar';
		opts.headerTitle = opts.headerTitle || i18n.t('i18n.working');
		opts.id = opts.id || 'app-progress-view';
		/**
		 * Never route to a progress view, and never accidentally un-route when we close one:
		 * @type {boolean}
		 */
		opts.isRouted = false;
		opts.loadingClassRemoveDelay = opts.loadingClassRemoveDelay || 300;
		opts.minimumShowTime = opts.minimumShowTime || 300;
		opts.modalOptions = {
			blocking: true,
			...opts.modalOptions,
		};
		opts.removeOnHide = opts.removeOnHide !== false;
		opts.template = opts.template || Template;
		super(opts);

		this.lastEventStr = this.eventStr = opts.eventStr;
		this.message = opts.message;
		this.simulate = opts.simulate !== false;

		// Hey listen!
		this.listenTo(
			dispatcher,
			`${this.eventStr}:success ${this.eventStr}:error`,
			_.debounce(this.complete, 500),
		);

		if (this.viewSpec) {
			this.listenTo(
				this.viewSpec,
				'change:viewOptions:eventStr',
				(viewSpec, eventStr, opts) => {
					this.hideTimeout && clearTimeout(this.hideTimeout);

					this.stopListening(
						dispatcher,
						`${this.lastEventStr}:success ${this.lastEventStr}:error`,
					);
					this.lastEventStr = eventStr;
					this.listenTo(
						dispatcher,
						`${eventStr}:success ${eventStr}:error`,
						_.debounce(this.complete, 500),
					);

					this.render();
				},
			);
		}
	}

	/** @override */
	preRender() {
		super.preRender();

		// We want nothing (for now at least)
		this.templateDataSource = {};
		// Additonal template vars
		Object.assign(this.templateVars, {
			message: this.message || '',
		});
	}

	/** @override */
	postRender() {
		super.postRender();

		// Cache the pseudo progress elements
		this.$pseudoProgress = this.$('.nx-control-pseudo-progress:first');
		this.$pseudoProgressBar = this.$pseudoProgress.find(
			'.nx-control-progress-bar',
		);

		// Simulation
		this.simulate && this.simulateProgress();
	}

	/** @method */
	complete() {
		this.hideTimeout && clearTimeout(this.hideTimeout);

		// Simulation
		this.simulate && this.endProgressSimulation();

		// // Give it a half a second
		if (this.hiding) {
			// Check if we are already hiding, since there is a delay - but let the view know there are no more simple hides
			delete this._simpleHide;
			return;
		}

		this.hideTimeout = setTimeout(() => {
			this.hide();
		}, 500);
	}

	/** @override */
	remove() {
		this.hideTimeout && clearTimeout(this.hideTimeout);
		super.remove();
	}

	/**
	 * @static
	 * @type {string}
	 */
	static get __name__() {
		return 'AppProgressView';
	}
}

export default AppProgressView;
